import React,{Component} from 'react';
import './Account.css';

import { 
    accountBackground, logo
} from '../../_utils/images';

// redux
import { connect } from 'react-redux';
import _ from 'lodash';
// import classNames from 'classnames';
import { API_URL } from '../../_utils/config';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Footer from '../../components/Footer/Footer';
import User from '@acri-tools/react-tools/components/User/User';
import Message from '@acri-tools/react-tools/components/Message/Message';
import routes from '../../_utils/routes';

import request from '@acri-tools/react-tools/utils/request';

interface Props{
    history?:any,

    // redux
    login?:any
}
interface State{
    user:any,
    updateUser: any,
    userUpdates: any,

    updateUserMessage:string,
    updateUserMessageType: string,

    change_email: string,

    updateEmailMessage: string,
    updateEmailMessageType: string,

    updateUserLoading?: boolean,
    updateEmailLoading?: boolean,
}




class Account extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            user: {},
            updateUser:{},
            userUpdates:{},

            updateUserMessage:'',
            updateUserMessageType: 'warn',

            change_email: '',

            updateEmailMessage:'',
            updateEmailMessageType: 'warn',
        }
    }

    componentDidMount(){
        let user = _.cloneDeep(this.props.login.user);
        delete user.password;
        this.setState({
            user: _.cloneDeep(user),
            updateUser: _.cloneDeep(user),
            userUpdates: {}
        })
    }
    render(){
        return (
        <Page 
            id="account"
            title="Account"
            footer={<Footer/>}
            banner={{
                bannerImage: accountBackground,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div">
                        <User 
                            update user={this.state.updateUser}
                            onChange={(update:any)=>{
                                this.setState({ updateUserMessage: '' });
                                let userUpdates:any = {
                                    ...this.state.userUpdates,
                                    ...update
                                };
                                Object.keys({...userUpdates}).forEach((property:string)=>{
                                    if( 
                                        userUpdates[property] === undefined 
                                        || userUpdates[property] === null
                                        || userUpdates[property] === ''
                                    ) delete userUpdates[property];
                                })
                                
                                this.setState({
                                    updateUser:{ ...this.state.updateUser, ...update },
                                    userUpdates
                                })
                            }}
                            onEnter={()=>{ this.updateUser() }}
                        />

                        <Message message={ this.state.updateUserMessage } type={ this.state.updateUserMessageType }/>

                        <div className="centered">
                            <div className="custom-button green medium inline" onClick={this.updateUser}><i className="fas fa-pen"/> UPDATE USER</div>
                        </div>
                    </div>


                    <div className="content-div"> 
                        <div className="title-2">Change Email</div>
                        <div className="form">
                            <div className="form-field">
                                <label>Email</label>
                                <input 
                                    type="email" value={this.state.change_email} placeholder={"Email"}
                                    onKeyDown={(e)=>{this.onEnter(e, this.updateEmail)}} onChange={(e)=>{ this.setState({ change_email: e.target.value }); }}/>
                            </div>
                        </div>

                        <Message message={ this.state.updateEmailMessage } type={ this.state.updateEmailMessageType }/>

                        <div className="centered">
                            <div className="custom-button blue medium inline" onClick={this.updateEmail}><i className="fas fa-envelope"/> UPDATE EMAIL</div>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
        );
    }

    onEnter = ( e:any, cb:any ) =>{
        if( e.keyCode === 13 ){
            if(cb) cb();
        }
    }
    


    updateUser = () =>{
        let userUpdates:any = this.state.userUpdates;
        let { confirm_password, password, old_password } = userUpdates;
        if(Object.keys(userUpdates).length === 0 ){
            this.setState({ updateUserMessage: 'No updates', updateUserMessageType: 'warn' });
        }
        else if( password && !old_password ){
            this.setState({ updateUserMessage: 'Missing previous password', updateUserMessageType: 'warn' });
        }
        else if( password && !confirm_password ){
            this.setState({ updateUserMessage: 'Missing confirm password', updateUserMessageType: 'warn' });
        }
        else if( password && password !== confirm_password ){
            this.setState({ updateUserMessage: 'Passwords do not match', updateUserMessageType: 'warn' });
        }
        else if("username" in this.state.user && window.confirm(`Are you sure you want to update user '${this.state.user["username"]}' ?`)){
            this.setState({ updateUserLoading:true });
            userUpdates = { ...userUpdates };
            delete userUpdates.confirm_password;
            request(`${API_URL}/api/user-manager/v1/users/${this.state.user?.id}`,{
                method:'put',
                data:{
                    ...userUpdates
                },
            })
            .then((res:any)=>{
                let updateUser:any = this.state.updateUser;
                updateUser.password = '';
                updateUser.confirm_password = '';
                updateUser.old_password = '';
                this.setState({ 
                    updateUserLoading:false,
                    updateUserMessage: `Successfully updated user`,
                    updateUserMessageType: 'success',
                    userUpdates: {},
                    updateUser
                });
            })
            .catch(e=>{
                this.setState({
                    updateUserLoading:false,
                    updateUserMessage: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                    updateUserMessageType: 'error'
                })
            })
        }
    }

    updateEmail = () =>{
        if( !this.state.change_email ){
            this.setState({ updateUserMessage: 'Please type your new email.', updateUserMessageType: 'warn' });
        }
        // else if( change_email ){
        //     this.setState({ updateUserMessage: 'Missing previous password', updateUserMessageType: 'warn' });
        // }
        else if(window.confirm(`Are you sure you want to update your email ?`)){
            this.setState({ updateEmailLoading:true });
            request(`${API_URL}/api/user-manager/v1/updateEmail`,{
                method:'post',
                data:{
                    email: this.state.change_email
                },
            })
            .then((res:any)=>{
                let updateUser:any = this.state.updateUser;
                updateUser.password = '';
                updateUser.confirm_password = '';
                updateUser.old_password = '';
                this.setState({ 
                    updateEmailLoading: false,
                    updateEmailMessage: `Successfully sent update email link to email ${this.state.change_email}`,
                    updateEmailMessageType: 'success',
                    change_email: ''
                });
            })
            .catch(e=>{
                this.setState({
                    updateEmailLoading:false,
                    updateEmailMessage: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                    updateEmailMessageType: 'error'
                })
            })
        }
    }

};


const mapStateToProps = (state: any) => {
    return {
        login: state.login,
        notifications: state.notifications,
    }
}

// export default App;
export default connect(mapStateToProps)(Account);
